import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import {getLocationFileAction, startUploadLocationsAction} from "pages/StoreFinderImport/actions";
import {extractResourceIdsWithPath, isNoU} from "utils/DBUtils";
import StoreLocationImporter from "components/forms/CustomFields/StoreLocationImporter";
import {startDeleteAction} from "../../pages/DeleteConfirmation/actions";
import {saveResourceChangelistSuccess} from "../../resources/actions";
import * as ResourceApi from "../../api/resources";

const mapStateToProps = (state, ownProps) => ({
    upload: state.storeFinderImport.upload
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => dispatch(startUploadLocationsAction(ownProps.formProxy.currentBaseResource, ownProps.formProxy.resourcePath, ownProps.formProxy.fieldPath)),
    removeLocations: (file) => {
        let changelist = {
            client: "",
            storeLocationFileId: null,
            storeLocationFile: null
        };

        let ids = extractResourceIdsWithPath(
          ownProps.formProxy.baseResource["MASTER"],
          ownProps.formProxy.currentBaseResource,
          ownProps.formProxy.resourcePath
        );

        let actions = [
            saveResourceChangelistSuccess(ResourceApi.Types.StoreFinderStep, ids[1].id, changelist, ids[1].id, ownProps.formProxy.resourcePath)
        ];

        return dispatch(startDeleteAction(
            file,
            file.resourceId,
            ids,
            {},
            actions
        ));
    },
    getLocationFile: (breakId, stepId) => dispatch(getLocationFileAction(breakId, stepId))
});

const OpenStoreFinderUploadButtonConnected = connect(mapStateToProps, mapDispatchToProps);

const OpenStoreFinderUploadButtonLifecycle = lifecycle({
    componentDidMount() {
        let proxy = this.props.formProxy;
        if (isNoU(proxy.currentResource.client) && isNoU(proxy.currentResource.storeLocationFile)) {
            let ids = extractResourceIdsWithPath(
              proxy.baseResource["MASTER"],
              proxy.currentBaseResource,
              proxy.resourcePath
            );
            // This component should only be on a store finder step
            // So 0 = breakId and 1 = stepId
            this.props.getLocationFile(ids[1].id, ids[0].id);
        }
    }
});

const OpenStoreFinderUploadButtonComposed = compose(
    OpenStoreFinderUploadButtonConnected,
    OpenStoreFinderUploadButtonLifecycle
)(StoreLocationImporter);

export default OpenStoreFinderUploadButtonComposed;



// WEBPACK FOOTER //
// ./public/components/composites/StoreLocationImporterConnected.jsx